<template>
  <div class="h-full rounded">
    <!-- RT PROMPT -->
    <tinymce idEditor="#editorOnlineRoundTable" :savedContent="form_data.prompt" @change="requestAutoSave" id="editorPrompt" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import debounce from 'lodash/debounce';
  import tinymce from 'components/textEditor/tinymce.vue';
  import { EventBus } from 'utils/event-bus';
  import theParlayTemplate from 'components/textEditor/templates/theParlayTemplate';
  export default {
    components: {
      tinymce,
    },
    data() {
      return {
        form_data: {
          prompt: '',
          rt_id: '111',
        },
      };
    },
    props: {
      savedPrompt: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    watch: {
      form_data() {
        this.debouncedSave();
      },
    },
    methods: {
      autoSave() {
        this.savePage(this.getCurrentRT.id);
      },
      requestAutoSave(eventData) {
        this.$emit('isSaving');
        this.form_data.prompt = eventData;
        this.debouncedSave();
        EventBus.$emit('promptChanged', this.form_data.prompt);
      },
      savePage(roundtableID) {
        if (!this.form_data.prompt) {
          return;
        }
        const data = { ...this.form_data, id: roundtableID };
        this.$emit('saveRoundtable', data);
      },
    },
    mounted() {
      this.debouncedSave = debounce(this.autoSave, 800, {
        leading: false,
        trailing: true,
      });
      if (this.$route.params.roundtableID === this.getCurrentRT.id) {
        this.form_data.prompt = this.getCurrentRT.prompt;
        this.form_data.rt_id = this.getCurrentRT.id;
      } else {
        this.form_data.prompt =
          this.savedPrompt === '' ? theParlayTemplate.prompt : this.savedPrompt;
      }
    },
  };
</script>

<style scoped lang="stylus">
  .tox-editor-header
    padding-top: 20px !important;
</style>



// WEBPACK FOOTER //
// editBuild.vue?58db19b4